// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Reset modal backdrop */
.login-container {
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #e5faf9;
  padding: 16px;
  position: relative;
}

/* Reset card styling */
.login-card {
  background-color: #ffffff;
  padding: 2rem;
  border-radius: 1rem;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.15);
  width: 100%;
  max-width: 420px;
  position: relative;
  text-align: center;
}

/* Logo container */
.logo-container {
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
}

/* Heading */
.welcome-text {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  color: #0f172a;
}

/* Input styling */
.input-login-container {
  width: 100%;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  border: 1px solid #cbd5e1;
  border-radius: 0.5rem;
  font-size: 1rem;
  outline: none;
  transition: border-color 0.2s;
}

.input-login-container:focus {
  border-color: #0d9488;
}

/* Password input with toggle button */
.password-input-container {
  position: relative;
}

.password-toggle-btn {
  position: absolute;
  top: 50%;
  right: 1rem;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  color: #64748b;
}

.password-instruction{
  font-size: 10px;
  color: #374151;
}

/* Buttons */
.reset-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1.5rem;
}

.credentials-button {
  flex: 1 1;
  padding: 0.75rem;
  font-size: 1rem;
  font-weight: 500;
  background-color: #f1f5f9;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: all 0.2s;
}

.credentials-button:hover {
  background-color: #e2e8f0;
}

/* Toast override (if needed) */
.toast-container {
  position: fixed;
  top: 1rem;
  right: 1rem;
  z-index: 1050;
}



@media screen and (max-width: 480px) {
  .login-card {
    padding: 1.5rem;
    margin: 0 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/loginComponent/ResetPassword.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,4CAA4C;EAC5C,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,+BAA+B;AAC/B;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,aAAa;AACf;;;;AAIA;EACE;IACE,eAAe;IACf,cAAc;EAChB;AACF","sourcesContent":["/* Reset modal backdrop */\r\n.login-container {\r\n  width: 100%;\r\n  min-height: 100vh;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  background-color: #e5faf9;\r\n  padding: 16px;\r\n  position: relative;\r\n}\r\n\r\n/* Reset card styling */\r\n.login-card {\r\n  background-color: #ffffff;\r\n  padding: 2rem;\r\n  border-radius: 1rem;\r\n  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.15);\r\n  width: 100%;\r\n  max-width: 420px;\r\n  position: relative;\r\n  text-align: center;\r\n}\r\n\r\n/* Logo container */\r\n.logo-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n/* Heading */\r\n.welcome-text {\r\n  font-size: 1.5rem;\r\n  font-weight: 600;\r\n  margin-bottom: 1.5rem;\r\n  color: #0f172a;\r\n}\r\n\r\n/* Input styling */\r\n.input-login-container {\r\n  width: 100%;\r\n  padding: 0.75rem 1rem;\r\n  margin-bottom: 1rem;\r\n  border: 1px solid #cbd5e1;\r\n  border-radius: 0.5rem;\r\n  font-size: 1rem;\r\n  outline: none;\r\n  transition: border-color 0.2s;\r\n}\r\n\r\n.input-login-container:focus {\r\n  border-color: #0d9488;\r\n}\r\n\r\n/* Password input with toggle button */\r\n.password-input-container {\r\n  position: relative;\r\n}\r\n\r\n.password-toggle-btn {\r\n  position: absolute;\r\n  top: 50%;\r\n  right: 1rem;\r\n  transform: translateY(-50%);\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  color: #64748b;\r\n}\r\n\r\n.password-instruction{\r\n  font-size: 10px;\r\n  color: #374151;\r\n}\r\n\r\n/* Buttons */\r\n.reset-buttons {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 1rem;\r\n  margin-top: 1.5rem;\r\n}\r\n\r\n.credentials-button {\r\n  flex: 1;\r\n  padding: 0.75rem;\r\n  font-size: 1rem;\r\n  font-weight: 500;\r\n  background-color: #f1f5f9;\r\n  border: none;\r\n  border-radius: 0.5rem;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.credentials-button:hover {\r\n  background-color: #e2e8f0;\r\n}\r\n\r\n/* Toast override (if needed) */\r\n.toast-container {\r\n  position: fixed;\r\n  top: 1rem;\r\n  right: 1rem;\r\n  z-index: 1050;\r\n}\r\n\r\n\r\n\r\n@media screen and (max-width: 480px) {\r\n  .login-card {\r\n    padding: 1.5rem;\r\n    margin: 0 1rem;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
